// components
import Link from 'next/link';
import RichText from '@/components/utilities/RichText';
import { Button } from '@/components/ui/button';
import { Icon } from '@/components/ui/icon';
import VisibleLoading from '@/components/utilities/VisibleLoading';

const CtaContainer = ({ claim, buttons, note }) => {
  return (
    <div className="mx-auto mt-26 mb-20 w-[90vw] text-center xl:w-(--container-width)">
      <div className="mx-auto max-w-[812px]">
        <VisibleLoading>
          {({ ref, className }) => (
            <h2 ref={ref} className={className}>
              <RichText>{claim}</RichText>
            </h2>
          )}
        </VisibleLoading>

        {(buttons || []).length > 0 && (
          <div className="mt-6 mb-6 flex flex-wrap justify-center gap-2">
            {buttons.map((button, index) => (
              <VisibleLoading key={button.id} delay={(index + 1) * 200}>
                {({ ref, className }) => (
                  <Button
                    ref={ref}
                    key={button.id}
                    variant={button.variant}
                    size={button.size}
                    asChild={true}
                    className={`basis-full xl:basis-auto ${className || ''}`.trim()}
                  >
                    <Link href={button.url || ''}>
                      <Icon type={button.icon} /> {button.label}
                    </Link>
                  </Button>
                )}
              </VisibleLoading>
            ))}
          </div>
        )}

        {note && (
          <VisibleLoading delay={300}>
            {({ ref, className }) => (
              <div ref={ref} className={`txt-md text-grey-700 mt-6 ${className}`.trim()}>
                {note}
              </div>
            )}
          </VisibleLoading>
        )}
      </div>
    </div>
  );
};
export default CtaContainer;
